(function() {
    var button = document.querySelector(".header__menu");
    var nav = document.getElementById("globalNav");
    if (!button || !nav) return;
    var root = document.documentElement;
    var pcQuery = window.matchMedia("(min-width: 768px)");
    function isOpen() {
        return button.getAttribute("aria-expanded") === "true";
    }
    function open() {
        button.setAttribute("aria-expanded", "true");
        button.setAttribute("aria-label", "メニューを閉じる");
        nav.classList.add("is-anim", "is-open");
        nav.removeAttribute("inert");
        root.classList.add("is-menu-open");
        nav.focus({
            preventScroll: true
        });
    }
    function close(returnFocus) {
        button.setAttribute("aria-expanded", "false");
        button.setAttribute("aria-label", "メニューを開く");
        nav.classList.remove("is-open");
        nav.setAttribute("inert", "");
        root.classList.remove("is-menu-open");
        if (returnFocus) button.focus({
            preventScroll: true
        });
    }
    button.addEventListener("click", function() {
        if (isOpen()) close(true); else open();
    });
    nav.addEventListener("click", function(e) {
        if (e.target.closest("a")) close(false);
    });
    document.addEventListener("keydown", function(e) {
        if (e.key === "Escape" && isOpen()) close(true);
    });
    pcQuery.addEventListener("change", function(e) {
        if (e.matches && isOpen()) close(false);
    });
    close(false);
})();

(function() {
    var dlg = document.getElementById("zoomView");
    if (!dlg || typeof dlg.showModal !== "function") return;
    var media = dlg.querySelector(".zoomview__media");
    var caption = dlg.querySelector(".zoomview__caption");
    var closeBtn = dlg.querySelector(".zoomview__close");
    var root = document.documentElement;
    var opener = null;
    function openZoom(trigger) {
        opener = trigger;
        var name = trigger.getAttribute("data-zoom-caption") || "";
        var src = trigger.getAttribute("data-zoom-src");
        media.textContent = "";
        if (src) {
            var img = document.createElement("img");
            img.className = "zoomview__img";
            img.src = src;
            img.alt = name;
            media.appendChild(img);
        } else {
            var ph = document.createElement("div");
            ph.className = "zoomview__ph";
            ph.setAttribute("role", "img");
            ph.setAttribute("aria-label", name + "の写真（準備中）");
            ph.innerHTML = "PHOTO<small></small>";
            ph.querySelector("small").textContent = trigger.getAttribute("data-zoom-shot") || "";
            media.appendChild(ph);
        }
        caption.textContent = name;
        dlg.showModal();
        root.classList.add("is-zoom-open");
        closeBtn.focus();
    }
    document.addEventListener("click", function(e) {
        var trigger = e.target.closest("[data-zoom]");
        if (trigger) openZoom(trigger);
    });
    function cleanup() {
        root.classList.remove("is-zoom-open");
        if (opener) opener.focus({
            preventScroll: true
        });
        opener = null;
    }
    function closeZoom() {
        if (dlg.open) dlg.close();
        cleanup();
    }
    closeBtn.addEventListener("click", closeZoom);
    dlg.addEventListener("click", function(e) {
        if (e.target === dlg) closeZoom();
    });
    dlg.addEventListener("close", cleanup);
})();

(function() {
    var chips = document.getElementById("facChips");
    var list = document.getElementById("facList");
    var more = document.getElementById("facMore");
    var select = document.getElementById("facPref");
    var empty = document.getElementById("facEmpty");
    if (!chips || !list || !more) return;
    var FIRST = 6;
    var AREAS = window.CCC_AREAS = [ [ "north", "北海道・東北" ], [ "kanto", "関東" ], [ "chubu", "甲信越・北陸" ], [ "tokai", "東海" ], [ "kansai", "関西" ], [ "chushi", "中国・四国" ], [ "kyushu", "九州・沖縄" ] ];
    var items = Array.prototype.slice.call(list.children);
    var cat = "all";
    var area = "";
    var opened = false;
    function areaOf(li) {
        return li.getAttribute("data-r") || "";
    }
    function matchCat(li, k) {
        return k === "all" || (li.getAttribute("data-k") || "").indexOf(k) !== -1;
    }
    function matchArea(li) {
        return !area || areaOf(li) === area;
    }
    if (select) {
        var count = {};
        items.forEach(function(li) {
            var r = areaOf(li);
            if (r) count[r] = (count[r] || 0) + 1;
        });
        AREAS.forEach(function(a) {
            if (!count[a[0]]) return;
            var o = document.createElement("option");
            o.value = a[0];
            o.textContent = a[1] + "（" + count[a[0]] + "）";
            select.appendChild(o);
        });
        select.closest(".facpref").hidden = false;
        select.addEventListener("change", function() {
            area = select.value;
            opened = false;
            draw();
        });
        window.CCC_setArea = function(r) {
            select.value = r;
            area = r;
            opened = false;
            draw();
        };
    }
    var chipList = Array.prototype.slice.call(chips.querySelectorAll(".chip"));
    chipList.forEach(function(chip) {
        chip.appendChild(document.createElement("small"));
    });
    function draw() {
        var shown = 0, total = 0;
        items.forEach(function(li) {
            if (!matchCat(li, cat) || !matchArea(li)) {
                li.hidden = true;
                return;
            }
            total++;
            li.hidden = !opened && shown >= FIRST;
            if (!li.hidden) shown++;
            li.querySelector(".fac__i").textContent = (total < 10 ? "0" : "") + total;
        });
        chipList.forEach(function(chip) {
            var k = chip.getAttribute("data-k");
            chip.querySelector("small").textContent = items.filter(function(li) {
                return matchCat(li, k) && matchArea(li);
            }).length;
        });
        if (empty) empty.hidden = total > 0;
        more.hidden = total <= FIRST;
        more.setAttribute("aria-expanded", String(opened));
        more.textContent = opened ? "閉じる" : total + "施設すべて見る";
    }
    chips.addEventListener("click", function(e) {
        var chip = e.target.closest(".chip");
        if (!chip) return;
        cat = chip.getAttribute("data-k");
        opened = false;
        chipList.forEach(function(c) {
            c.setAttribute("aria-pressed", String(c === chip));
        });
        draw();
    });
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
    var anim = null;
    function slide(from, to, done) {
        if (anim) {
            var prev = anim;
            anim = null;
            prev.cancel();
            list.classList.remove("is-animating");
        }
        if (reduce.matches || !list.animate || from === to) {
            if (done) done();
            return;
        }
        list.classList.add("is-animating");
        var ms = Math.min(700, 250 + Math.abs(to - from) * .12);
        var a = anim = list.animate([ {
            height: from + "px"
        }, {
            height: to + "px"
        } ], {
            duration: ms,
            easing: "ease"
        });
        var ended = false;
        function end() {
            if (ended || anim !== a) return;
            ended = true;
            anim = null;
            a.cancel();
            list.classList.remove("is-animating");
            if (done) done();
        }
        a.finished.then(end, function() {});
        setTimeout(end, ms + 60);
    }
    more.addEventListener("click", function() {
        var from = list.getBoundingClientRect().height;
        if (!opened) {
            opened = true;
            draw();
            slide(from, list.getBoundingClientRect().height);
            return;
        }
        if (anim) {
            anim.cancel();
            anim = null;
            list.classList.remove("is-animating");
        }
        var partner = document.getElementById("partner") || list;
        var header = document.querySelector(".header");
        var offset = header ? header.getBoundingClientRect().height : 0;
        var top = Math.max(0, window.scrollY + partner.getBoundingClientRect().top - offset - 12);
        // Collapse and reposition together so changing document height cannot move the viewport elsewhere.
        opened = false;
        draw();
        window.scrollTo({ top: top, behavior: "instant" });
    });
    draw();
})();

(function() {
    var bar = document.getElementById("ctaBar");
    if (!bar) return;
    var final = document.getElementById("final");
    var finalVisible = false;
    bar.hidden = false;
    function update() {
        var past = window.scrollY > window.innerHeight * .8;
        bar.classList.toggle("is-show", past && !finalVisible);
    }
    if (final && "IntersectionObserver" in window) {
        new IntersectionObserver(function(entries) {
            finalVisible = entries[0].isIntersecting;
            update();
        }, {
            threshold: .35
        }).observe(final);
    }
    window.addEventListener("scroll", update, {
        passive: true
    });
    window.addEventListener("resize", update);
    update();
})();

// Verified CTA destinations; product presentation follows the launch/preview state.
window.CCC_CTA_CONFIG = Object.assign({

    purchaseUrl: "https://cargo-container.shop/products/ccc",
    nextRecruitmentUrl: "https://cargocontainer.ecai.jp/optin/1?ecaiad=EjhKTmun",
    variantId: "47968352862466",
    sellingPlanId: "7214530818",
    giftVariantId: "50546614436098",
    rootUrl: "/"
}, window.CCC_CTA_CONFIG || {});
// Share the same simulated clock between purchase controls and all countdowns.
var cccPreviewMode = new URLSearchParams(location.search).get("ccc-preview");
var cccPreviewLoadedAt = Date.now();
function cccLaunchNow(start) {
    var now = Date.now();
    if (cccPreviewMode === "open") return start + (now - cccPreviewLoadedAt);
    if (cccPreviewMode === "before") return Math.min(start - 1, start - 3600000 + (now - cccPreviewLoadedAt));
    if (cccPreviewMode === "closed") {
        var countdown = document.getElementById("fvCount");
        return Date.parse(countdown.getAttribute("data-deadline")) + 1000 + (now - cccPreviewLoadedAt);
    }
    return now;
}
(function() {
    var config = window.CCC_CTA_CONFIG;
    var countdown = document.getElementById("fvCount");
    if (!countdown) return;
    var start = Date.parse(countdown.getAttribute("data-start"));
    var end = Date.parse(countdown.getAttribute("data-deadline"));
    // Explicit preview URL works on Shopify too; normal URLs follow the launch clock.
    // This is a testing switch, not an access-control mechanism.
    function currentStage() {
        var now = cccLaunchNow(start);
        return now < start ? "before" : now >= end ? "closed" : "open";
    }
    var links = document.querySelectorAll("[data-ccc-cta]");
    var previous = null;
    var cccCtaSubmitting = false;
    function update() {
        var stage = currentStage();
        if (previous === stage) return;
        previous = stage;
        var url = stage === "open" ? config.purchaseUrl : stage === "closed" ? config.nextRecruitmentUrl : "";
        var validUrl = /^https:\/\//.test(url);
        links.forEach(function(link) {
            var label = link.querySelector(".stage-cta__mini-btn, .cta__label") || link;
            label.textContent = stage === "open" ? "今すぐ入会する" : stage === "closed" ? "次回募集の案内を受け取る" : "10月3日 募集開始";
            link.classList.toggle("is-closed", stage === "closed");
            if (validUrl) {
                link.href = url;
                link.removeAttribute("data-pending");
                link.removeAttribute("aria-disabled");
            } else {
                link.removeAttribute("href");
                link.setAttribute("data-pending", "");
                link.setAttribute("aria-disabled", "true");
            }
        });
        document.querySelectorAll(".stage-cta__mini-badge").forEach(function(el) {
            el.textContent = stage === "open" ? "創設メンバー募集中" : stage === "closed" ? "募集終了" : "10月3日 募集開始";
        });
        document.querySelectorAll(".membership-product").forEach(function(el) {
            el.classList.toggle("is-prelaunch", stage !== "open");
        });
        document.querySelectorAll(".stage-cta__note, .cta__pre").forEach(function(el) {
            if (!el.hasAttribute("data-join-copy")) el.setAttribute("data-join-copy", el.textContent);
            el.textContent = stage === "closed" ? "次回の募集はLINEでお知らせします" : el.getAttribute("data-join-copy");
        });
    }
    update();
    setInterval(update, 1000);
    document.addEventListener("visibilitychange", update);
    document.addEventListener("click", async function(event) {
        var link = event.target.closest("[data-ccc-cta]");
        if (!link || currentStage() !== "open") return;
        event.preventDefault();
        if (cccCtaSubmitting) return;
        cccCtaSubmitting = true;
        links.forEach(function(cta) {
            cta.setAttribute("aria-busy", "true");
        });
        try {
            var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || config.rootUrl || "/";
            if (rootUrl.slice(-1) !== "/") rootUrl += "/";
            var cartResponse = await fetch(rootUrl + "cart.js", {
                credentials: "same-origin",
                cache: "no-store",
                headers: { Accept: "application/json" }
            });
            if (!cartResponse.ok) throw new Error("Cart fetch failed: " + cartResponse.status);
            var cart = await cartResponse.json();
            var hasMembership = cart.items.some(function(item) {
                return String(item.variant_id) === String(config.variantId);
            });
            var hasGift = cart.items.some(function(item) {
                return String(item.variant_id) === String(config.giftVariantId);
            });
            var items = [];
            if (!hasMembership) {
                items.push({
                    id: Number(config.variantId),
                    quantity: 1,
                    selling_plan: Number(config.sellingPlanId)
                });
            }
            if (!hasGift) {
                items.push({
                    id: Number(config.giftVariantId),
                    quantity: 1,
                    properties: { _ccc_welcome_gift: "初回入会特典" }
                });
            }
            if (items.length) {
                var addResponse = await fetch(rootUrl + "cart/add.js", {
                    method: "POST",
                    credentials: "same-origin",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ items: items })
                });
                if (!addResponse.ok) throw new Error("Cart add failed: " + addResponse.status);
            }
            window.location.assign(rootUrl + "checkout");
        } catch (error) {
            console.error("CCC checkout setup failed", error);
            cccCtaSubmitting = false;
            links.forEach(function(cta) {
                cta.removeAttribute("aria-busy");
            });
            window.alert("カートの準備が完了しませんでした。ページを再読み込みして、もう一度お試しください。");
        }
    });
})();

document.addEventListener("click", function(e) {
    var a = e.target.closest("a[data-pending]");
    if (a) e.preventDefault();
});

(function() {
    var map = document.getElementById("jmap");
    var dlg = document.getElementById("mapPop");
    var list = document.getElementById("facList");
    if (!map || !dlg || !list || typeof dlg.showModal !== "function") return;
    var head = dlg.querySelector(".mappop__head");
    var body = dlg.querySelector(".mappop__list");
    var closeBtn = dlg.querySelector(".mappop__close");
    var root = document.documentElement;
    var opener = null;
    var GIFT = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3 9h8.2v4H3zM12.8 9H21v4h-8.2zM4 14.4h7.2V21H4zM12.8 14.4H20V21h-7.2z"/><path d="M12 8.2c-1-3.2-2.6-5-4.3-5-1.3 0-2.2.9-2.2 2.1 0 1.9 2.5 2.9 6.5 2.9zm0 0c1-3.2 2.6-5 4.3-5 1.3 0 2.2.9 2.2 2.1 0 1.9-2.5 2.9-6.5 2.9z" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
    var NAME = {};
    (window.CCC_AREAS || []).forEach(function(a) {
        NAME[a[0]] = a[1];
    });
    var byArea = {};
    Array.prototype.forEach.call(list.children, function(li) {
        var r = li.getAttribute("data-r");
        if (!r) return;
        (byArea[r] = byArea[r] || []).push(li);
    });
    Array.prototype.forEach.call(map.querySelectorAll(".jmap__t"), function(t) {
        var r = t.getAttribute("data-r");
        if (!byArea[r]) return;
        t.classList.add("is-tap");
        t.setAttribute("role", "button");
        t.setAttribute("tabindex", "0");
        t.setAttribute("aria-label", t.textContent.trim() + "をふくむ" + (NAME[r] || "") + "の提携施設を見る");
    });
    function hot(r) {
        map.classList.toggle("is-hot", !!r);
        Array.prototype.forEach.call(map.querySelectorAll(".jmap__t"), function(t) {
            t.classList.toggle("is-hot", !!r && t.getAttribute("data-r") === r);
        });
    }
    map.addEventListener("pointerover", function(e) {
        var t = e.target.closest(".jmap__t.is-tap");
        hot(t ? t.getAttribute("data-r") : "");
    });
    map.addEventListener("pointerleave", function() {
        hot("");
    });
    map.addEventListener("focusin", function(e) {
        var t = e.target.closest(".jmap__t.is-tap");
        if (t) hot(t.getAttribute("data-r"));
    });
    map.addEventListener("focusout", function() {
        hot("");
    });
    function esc(s) {
        return s.replace(/[&<>"]/g, function(c) {
            return {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;"
            }[c];
        });
    }
    function openPop(tile) {
        var r = tile.getAttribute("data-r");
        var items = byArea[r] || [];
        opener = tile;
        head.textContent = (NAME[r] || "") + "（" + items.length + "施設）";
        body.innerHTML = items.map(function(li) {
            var b = li.querySelector(".fac__b");
            var pref = li.querySelector(".fac__pref");
            return "<li>" + GIFT + '<div><p class="mappop__n">' + esc(li.querySelector(".fac__n").textContent) + "</p>" + '<p class="mappop__b' + (b.classList.contains("tbd") ? " tbd" : "") + '">' + '<span class="mappop__p">' + esc(pref ? pref.textContent : "") + "</span>" + esc(b.textContent) + "</p></div></li>";
        }).join("");
        body.scrollTop = 0;
        dlg.showModal();
        root.classList.add("is-pop-open");
        closeBtn.focus();
    }
    map.addEventListener("click", function(e) {
        var t = e.target.closest(".jmap__t.is-tap");
        if (t) openPop(t);
    });
    map.addEventListener("keydown", function(e) {
        var t = e.target.closest(".jmap__t.is-tap");
        if (t && (e.key === "Enter" || e.key === " ")) {
            e.preventDefault();
            openPop(t);
        }
    });
    function cleanup() {
        root.classList.remove("is-pop-open");
        hot("");
        if (opener) opener.focus({
            preventScroll: true
        });
        opener = null;
    }
    function closePop() {
        if (dlg.open) dlg.close();
        cleanup();
    }
    closeBtn.addEventListener("click", closePop);
    dlg.addEventListener("click", function(e) {
        if (e.target === dlg) closePop();
    });
    dlg.addEventListener("close", cleanup);
})();

(function() {
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
    Array.prototype.forEach.call(document.querySelectorAll(".faq details"), function(d) {
        var summary = d.querySelector("summary");
        var anim = null;
        if (d.open) d.classList.add("is-open");
        function run(from, to, after) {
            if (anim) {
                var prev = anim;
                anim = null;
                prev.cancel();
            }
            d.classList.add("is-animating");
            var a = anim = d.animate([ {
                height: from + "px"
            }, {
                height: to + "px"
            } ], {
                duration: 320,
                easing: "ease"
            });
            var ended = false;
            function end() {
                if (ended || anim !== a) return;
                ended = true;
                anim = null;
                a.cancel();
                d.classList.remove("is-animating");
                if (after) after();
            }
            a.finished.then(end, function() {});
            setTimeout(end, 380);
        }
        summary.addEventListener("click", function(e) {
            if (reduce.matches || !d.animate) {
                d.classList.toggle("is-open", !d.open);
                return;
            }
            e.preventDefault();
            var start = d.getBoundingClientRect().height;
            var closed = summary.getBoundingClientRect().height;
            if (!d.open || !d.classList.contains("is-open")) {
                d.open = true;
                d.classList.add("is-open");
                run(start, d.getBoundingClientRect().height);
            } else {
                d.classList.remove("is-open");
                run(start, closed, function() {
                    d.open = false;
                });
            }
        });
    });
})();

(function() {
    var box = document.getElementById("fvCount");
    if (!box) return;
    var end = new Date(box.getAttribute("data-deadline")).getTime();
    if (isNaN(end)) return;
    var start = new Date(box.getAttribute("data-start")).getTime();
    var opened = false;
    var targets = [ box, document.getElementById("stageCount"), document.getElementById("barCount") ].filter(Boolean).map(function(b) {
        var el = {
            box: b,
            time: b.querySelector('[class$="count-time"], [class$="count__time"]')
        };
        Array.prototype.forEach.call(b.querySelectorAll("[data-u]"), function(x) {
            el[x.getAttribute("data-u")] = x;
        });
        return el;
    });
    var timer = null;
    function pad(n) {
        return (n < 10 ? "0" : "") + n;
    }
    function put(b, str) {
        if (b.getAttribute("data-v") === str) return;
        b.setAttribute("data-v", str);
        b.innerHTML = str.split("").map(function(c) {
            return "<i>" + c + "</i>";
        }).join("");
    }
    function tick() {
        var now = cccLaunchNow(start);
        if (!opened && !(now < start)) {
            opened = true;
            targets.forEach(function(t) {
                Array.prototype.forEach.call(t.box.querySelectorAll("[data-open]"), function(x) {
                    x.innerHTML = x.getAttribute("data-open");
                });
            });
        }
        var left = Math.max(0, Math.floor(((opened ? end : start) - now) / 1e3));
        if (left <= 0) {
            targets.forEach(function(t) {
                t.box.classList.add("is-ended");
                t.time.textContent = "創設メンバーの募集は終了しました";
            });
            if (timer) clearTimeout(timer);
            return;
        }
        targets.forEach(function(t) {
            put(t.d, String(Math.floor(left / 86400)));
            put(t.h, pad(Math.floor(left % 86400 / 3600)));
            put(t.m, pad(Math.floor(left % 3600 / 60)));
            put(t.s, pad(left % 60));
        });
        timer = setTimeout(tick, 1e3 - Date.now() % 1e3 + 20);
    }
    tick();
})();

(function() {
    var sc = document.getElementById("stageCount");
    var about = document.getElementById("about");
    if (!sc || !about) return;
    function update() {
        var header = document.querySelector(".header");
        var line = header ? header.getBoundingClientRect().bottom : 0;
        var show = about.getBoundingClientRect().top <= line + 1;
        sc.classList.toggle("is-show", show);
    }
    window.addEventListener("scroll", update, {
        passive: true
    });
    window.addEventListener("resize", update);
    update();
})();

(function() {
    var links = Array.prototype.slice.call(document.querySelectorAll('.stage-nav a[href^="#"]'));
    if (!links.length) return;
    var pairs = links.map(function(a) {
        return {
            a: a,
            sec: document.getElementById(a.getAttribute("href").slice(1))
        };
    }).filter(function(p) {
        return p.sec;
    });
    var current = null;
    var queued = false;
    function update() {
        queued = false;
        var line = window.innerHeight / 3;
        var now = pairs[0];
        pairs.forEach(function(p) {
            if (p.sec.getBoundingClientRect().top <= line) now = p;
        });
        if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) now = pairs[pairs.length - 1];
        if (now === current) return;
        if (current) {
            current.a.classList.remove("is-current");
            current.a.removeAttribute("aria-current");
        }
        now.a.classList.add("is-current");
        now.a.setAttribute("aria-current", "location");
        current = now;
    }
    function onScroll() {
        if (!queued) {
            queued = true;
            requestAnimationFrame(update);
        }
    }
    window.addEventListener("scroll", onScroll, {
        passive: true
    });
    window.addEventListener("resize", onScroll);
    update();
})();

(function() {
    var dlg = document.getElementById("legalPop");
    if (!dlg || typeof dlg.showModal !== "function") return;
    var head = dlg.querySelector(".legalpop__head");
    var body = dlg.querySelector(".legalpop__body");
    var closeBtn = dlg.querySelector(".legalpop__close");
    var sections = Array.prototype.slice.call(dlg.querySelectorAll(".legal[data-legal]"));
    var root = document.documentElement;
    var opener = null;
    function open(key, trigger) {
        var sec = null;
        sections.forEach(function(s) {
            var on = s.getAttribute("data-legal") === key;
            s.hidden = !on;
            if (on) sec = s;
        });
        if (!sec) return;
        opener = trigger || null;
        head.textContent = sec.getAttribute("data-title");
        dlg.showModal();
        body.scrollTop = 0;
        root.classList.add("is-legal-open");
        closeBtn.focus();
    }
    function cleanup() {
        root.classList.remove("is-legal-open");
        if (opener) opener.focus({
            preventScroll: true
        });
        opener = null;
    }
    function close() {
        if (dlg.open) dlg.close();
        cleanup();
    }
    document.addEventListener("click", function(e) {
        var a = e.target.closest("a[data-legal]");
        if (!a) return;
        e.preventDefault();
        open(a.getAttribute("data-legal"), a);
    });
    closeBtn.addEventListener("click", close);
    dlg.addEventListener("click", function(e) {
        if (e.target === dlg) {
            close();
            return;
        }
        var link = e.target.closest("[data-legal-close]");
        if (link) {
            opener = null;
            close();
        }
    });
    dlg.addEventListener("close", cleanup);
})();

(function() {
    var doors = document.querySelectorAll('.door[data-anim="door"]');
    if (!doors.length || !("IntersectionObserver" in window)) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
            if (!e.isIntersecting) return;
            e.target.classList.add("is-in");
            io.unobserve(e.target);
        });
    }, {
        threshold: .25
    });
    Array.prototype.forEach.call(doors, function(door) {
        var title = door.querySelector(".door__title");
        if (title && !title.querySelector(".ln")) {
            title.innerHTML = title.innerHTML.split(/<br\s*\/?>/i).map(function(line, i) {
                return '<span class="ln" style="--i:' + i + '"><span class="ln__in">' + line + "</span></span>";
            }).join("");
        }
        door.classList.add("is-ready");
        io.observe(door);
    });
})();

(function() {
    var els = document.querySelectorAll("[data-count]");
    if (!els.length || !("IntersectionObserver" in window)) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    function format(v, decimals, comma) {
        var str = v.toFixed(decimals);
        if (!comma) return str;
        var parts = str.split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    }
    function render(el, str) {
        var w = el.getAttribute("data-dw");
        el.innerHTML = str.split("").map(function(c) {
            return /\d/.test(c) ? '<span style="display:inline-block;width:' + w + 'px;text-align:center;font-size:inherit;margin:0;padding:0">' + c + "</span>" : c;
        }).join("");
    }
    function start(el) {
        var text = el.getAttribute("data-final");
        var m = text.match(/^(\D*)([\d,]*\.?\d+)(.*)$/);
        if (!m) return;
        var prefix = m[1], numStr = m[2], suffix = m[3];
        var comma = numStr.indexOf(",") !== -1;
        var decimals = (numStr.split(".")[1] || "").length;
        var target = parseFloat(numStr.replace(/,/g, ""));
        var t0 = null, DUR = 1200, done = false;
        function finish() {
            if (done) return;
            done = true;
            render(el, text);
        }
        function frame(now) {
            if (done) return;
            if (t0 === null) t0 = now;
            var p = Math.min(1, (now - t0) / DUR);
            var eased = 1 - Math.pow(1 - p, 3);
            if (p >= 1) {
                finish();
                return;
            }
            var s = format(target * eased, decimals, false);
            var full = format(target, decimals, false);
            while (s.length < full.length) s = "0" + s;
            if (comma) {
                var parts = s.split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                s = parts.join(".");
            }
            render(el, prefix + s + suffix);
            requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
        setTimeout(finish, DUR + 300);
    }
    var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
            if (!e.isIntersecting) return;
            io.unobserve(e.target);
            start(e.target);
        });
    }, {
        threshold: .6
    });
    var ready = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    ready.then(function() {
        Array.prototype.forEach.call(els, prepare);
    });
    function prepare(el) {
        var text = el.textContent.trim();
        el.setAttribute("data-final", text);
        var probe = document.createElement("span");
        probe.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap;font-size:inherit";
        el.appendChild(probe);
        var dw = 0;
        for (var d = 0; d < 10; d++) {
            probe.textContent = String(d);
            dw = Math.max(dw, probe.getBoundingClientRect().width);
        }
        el.removeChild(probe);
        el.setAttribute("data-dw", (Math.ceil(dw * 10) / 10).toFixed(1));
        el.style.display = "inline-block";
        el.style.whiteSpace = "nowrap";
        render(el, text.replace(/[\d]/g, "0"));
        io.observe(el);
    }
})();

(function() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    Array.prototype.forEach.call(document.querySelectorAll('img[loading="lazy"]'), function(img) {
        if (img.complete) return;
        img.classList.add("img-wait");
        function show() {
            img.classList.remove("img-wait");
            img.classList.add("img-in");
        }
        img.addEventListener("load", show, {
            once: true
        });
        img.addEventListener("error", function() {
            img.classList.remove("img-wait");
        }, {
            once: true
        });
        setTimeout(function() {
            if (img.classList.contains("img-wait")) img.classList.remove("img-wait");
        }, 8e3);
    });
})();

(function() {
    var cards = document.querySelectorAll(".acts li");
    if (!cards.length || !("IntersectionObserver" in window)) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
            if (!e.isIntersecting) return;
            e.target.classList.add("is-jump");
            io.unobserve(e.target);
        });
    }, {
        threshold: .5
    });
    Array.prototype.forEach.call(cards, function(c) {
        io.observe(c);
    });
})();

(function() {
    var grid = document.querySelector(".tiles");
    if (!grid || !("IntersectionObserver" in window)) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    Array.prototype.forEach.call(grid.children, function(li, t) {
        li.style.setProperty("--t", t);
        var ja = li.querySelector(".tiles__ja");
        if (!ja) return;
        var n = 0;
        (function split(node) {
            Array.prototype.slice.call(node.childNodes).forEach(function(c) {
                if (c.nodeType === 3) {
                    var frag = document.createDocumentFragment();
                    c.textContent.split("").forEach(function(ch) {
                        var s = document.createElement("span");
                        s.className = "ch";
                        s.style.setProperty("--c", n++);
                        s.textContent = ch;
                        frag.appendChild(s);
                    });
                    node.replaceChild(frag, c);
                } else if (c.nodeType === 1 && c.tagName !== "BR") {
                    split(c);
                }
            });
        })(ja);
    });
    grid.classList.add("is-ready");
    var io = new IntersectionObserver(function(entries) {
        if (!entries[0].isIntersecting) return;
        grid.classList.add("is-in");
        io.disconnect();
    }, {
        threshold: .33
    });
    io.observe(grid);
})();

(function() {
    var els = document.querySelectorAll('[data-anim="closing"]');
    if (!els.length || !("IntersectionObserver" in window)) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
            if (!e.isIntersecting) return;
            e.target.classList.add("is-in");
            io.unobserve(e.target);
        });
    }, {
        threshold: .5
    });
    Array.prototype.forEach.call(els, function(el) {
        var lead = el.querySelector(".item__closing-lead");
        if (lead && !lead.querySelector(".rv-ln")) {
            lead.innerHTML = lead.innerHTML.split(/<br\s*\/?>/i).map(function(line, i) {
                return '<span class="rv-ln" style="--i:' + i + '"><span class="rv-ln__in">' + line + "</span></span>";
            }).join("");
        }
        el.classList.add("is-ready");
        io.observe(el);
    });
})();

(function() {
    var app = document.querySelector(".rooms__app");
    if (!app || !("IntersectionObserver" in window)) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var items = Array.prototype.slice.call(app.querySelectorAll("dt, dd span"));
    function order() {
        items.map(function(el) {
            var r = el.getBoundingClientRect();
            return {
                el: el,
                y: Math.round(r.top),
                x: r.left
            };
        }).sort(function(a, b) {
            return a.y - b.y || a.x - b.x;
        }).forEach(function(o, k) {
            o.el.style.setProperty("--k", k);
        });
    }
    var ready = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    ready.then(function() {
        order();
        app.classList.add("is-ready");
        var io = new IntersectionObserver(function(entries) {
            if (!entries[0].isIntersecting) return;
            app.classList.add("is-in");
            io.disconnect();
        }, {
            threshold: .25
        });
        io.observe(app);
    });
})();

(function() {
    if (!("IntersectionObserver" in window)) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var list = [ {
        root: ".pf__three",
        items: "li > p"
    }, {
        root: ".vgrid",
        items: "li"
    }, {
        root: ".tl",
        items: "li"
    }, {
        root: ".special",
        items: "li"
    }, {
        root: ".steps",
        items: "li"
    }, {
        root: ".sold",
        items: "li"
    }, {
        root: ".gear",
        items: "li"
    } ];
    var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
            if (!e.isIntersecting) return;
            e.target.classList.add("rv-in");
            io.unobserve(e.target);
        });
    }, {
        threshold: .25
    });
    list.forEach(function(c) {
        Array.prototype.forEach.call(document.querySelectorAll(c.root), function(root) {
            Array.prototype.forEach.call(root.querySelectorAll(c.items), function(el, k) {
                el.classList.add("rv-item");
                el.style.setProperty("--k", k);
                Array.prototype.forEach.call(el.querySelectorAll(".vgrid__bars i, .special__bow, .steps__icon, .ribbon"), function(x) {
                    x.style.setProperty("--k", k);
                });
            });
            root.classList.add("rv-ready");
            io.observe(root);
        });
    });
})();

(function() {
    var wrap = document.querySelector(".lab__cards");
    if (!wrap || !("IntersectionObserver" in window)) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
            if (!e.isIntersecting) return;
            e.target.classList.add("is-zoom");
            io.unobserve(e.target);
        });
    }, {
        threshold: .33
    });
    wrap.classList.add("zm-ready");
    Array.prototype.forEach.call(wrap.children, function(li) {
        io.observe(li);
    });
})();

(function() {
    var imgs = Array.prototype.slice.call(document.querySelectorAll("img[data-parallax]"));
    if (!imgs.length || !("IntersectionObserver" in window)) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var RANGE = .1;
    var active = [];
    var queued = false;
    function update() {
        queued = false;
        var vh = window.innerHeight;
        active.forEach(function(img) {
            var box = img.__pxBox.getBoundingClientRect();
            var p = (vh / 2 - (box.top + box.height / 2)) / ((vh + box.height) / 2);
            p = Math.max(-1, Math.min(1, p));
            img.style.transform = "translate3d(0," + (p * RANGE * box.height).toFixed(1) + "px,0)";
        });
    }
    function onScroll() {
        if (queued || !active.length) return;
        queued = true;
        requestAnimationFrame(update);
    }
    var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
            var img = e.target.__pxImg;
            var i = active.indexOf(img);
            if (e.isIntersecting && i === -1) active.push(img);
            if (!e.isIntersecting && i !== -1) active.splice(i, 1);
        });
        onScroll();
    });
    imgs.forEach(function(img) {
        var box = img.parentElement;
        if (box.tagName === "PICTURE") box = box.parentElement;
        img.__pxBox = box;
        img.classList.add("px-on");
        box.style.overflow = "hidden";
        box.__pxImg = img;
        io.observe(box);
    });
    window.addEventListener("scroll", onScroll, {
        passive: true
    });
    window.addEventListener("resize", onScroll);
})();

/* FV: 自動再生できない環境では静止画を表示する */
(function() {
    function init() {
        var video = document.querySelector('.fv__video');
        if (!video) return;
        var timer;
        function hide() {
            clearTimeout(timer);
            video.classList.remove('is-playing');
        }
        function reveal() {
            clearTimeout(timer);
            timer = setTimeout(function() {
                if (!video.paused && video.readyState >= 2) video.classList.add('is-playing');
            }, 0);
        }
        video.addEventListener('playing', reveal);
        video.addEventListener('pause', hide);
        video.addEventListener('error', hide);
        video.addEventListener('emptied', hide);
        if (!video.paused && video.readyState >= 2) reveal();
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
        init();
    }
})();
